import { Component } from "@angular/core"

import { HomePage } from "../home"
import { EventsPage } from "../events"
import { SettingsPage } from "../settings"

@Component({
  templateUrl: "index.html"
})
export class AppTabPages {

  homePage = HomePage
  eventsPage = EventsPage
  settingsPage = SettingsPage
}



// WEBPACK FOOTER //
// ./src/pages/tabs/index.ts